import React from 'react';
import { MailIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="py-16" data-id="element-79" data-mp="3ggar7wn6mf5z">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-80" data-mp="3ggk90wy2pg0l">
        <p className="text-sm font-semibold uppercase tracking-[0.25em] text-[var(--gold)]" data-id="element-81" data-mp="32onkt3zizq9h">
          🧘 Tu Plataforma Digital™
        </p>
        <p className="mx-auto mt-4 max-w-xl text-white/70" data-id="element-82" data-mp="36ppn5toqoifo">
          El sistema número uno para profesoras y profesores de Pilates en
          Argentina.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-white/55" data-id="element-83" data-mp="37o6qw57hzdw">
          Porque enseñar Pilates no debería costarte todos los domingos del año.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/70" data-id="element-84" data-mp="3qdf5796vj4bp">
          <a href="mailto:soportetuplataformadigital@gmail.com" className="inline-flex items-center gap-2 transition-colors hover:text-[var(--gold-light)]" data-id="element-85" data-mp="29zgkbzgigqll">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-86" data-mp="3l9adtjp9964y" />
            soportetuplataformadigital@gmail.com
          </a>
          <a href="https://www.tuplataformadigital.store" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 transition-colors hover:text-[var(--gold-light)]" data-id="element-87" data-mp="3gb8xv7n4lmxp">
            <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-88" data-mp="3qazr75zy9vw7" />
            www.tuplataformadigital.store
          </a>
        </div>

        <div className="mt-10 border-t border-white/10 pt-8" data-id="element-89" data-mp="34gxxkciex96">
          <p className="text-xs text-white/40" data-id="element-90" data-mp="31umh9mhzxlo">
            © Tu Plataforma Digital™ 2026 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="mt-6 font-serif-display text-xl italic text-[var(--gold-light)]" data-id="element-91" data-mp="qthzcnmxd84y">
            “El próximo lunes puede ser diferente.”
          </p>
        </div>
      </div>
    </footer>;
}